import { template as template_27c28bdb3a7d48e89270a4a04dacb852 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import ModuleTemplate from 'ember-route-template';
import type { Model } from '../routes/module';
const { stringify } = JSON;
export default ModuleTemplate(template_27c28bdb3a7d48e89270a4a04dacb852(`
  <div
    data-prerender-module
    data-prerender-module-id={{@model.id}}
    data-prerender-module-nonce={{@model.nonce}}
    data-prerender-module-status={{@model.status}}
  >
    <pre>{{stringify @model null 2}}</pre>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
